import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const LogoutIcon = ({ label = 'Logout', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M87.9 179.6a8.6 8.6 0 0 0 8.6 8.6h77.7v50.7a4.2 4.2 0 0 0 7.3 3l76.4-77.2a8.6 8.6 0 0 0 0-12.2l-76.4-77.2a4.3 4.3 0 0 0-7.3 3V129H96.5a8.6 8.6 0 0 0-8.6 8.6z" style="fill:#ee8875"/><path d="M178.5 74a3.9 3.9 0 0 1 3 1.3l76.4 77.2a8.6 8.6 0 0 1 0 12.2l-76.4 77.2a3.9 3.9 0 0 1-3 1.3 4.3 4.3 0 0 1-4.3-4.3v-50.7H96.5a8.6 8.6 0 0 1-8.6-8.6v-42a8.6 8.6 0 0 1 8.6-8.6h77.7V78.3a4.3 4.3 0 0 1 4.3-4.3m0-10a14.3 14.3 0 0 0-14.3 14.3V119H96.5a18.6 18.6 0 0 0-18.6 18.6v42a18.6 18.6 0 0 0 18.6 18.6h67.7v40.7a14.3 14.3 0 0 0 24.4 10.1l76.4-77.2a18.6 18.6 0 0 0 0-26.4l-76.4-77.2a14.2 14.2 0 0 0-10.1-4.2z" style="fill:#1d1d1b"/><path d="M166.7 247.2H58.9a20.7 20.7 0 0 1-20.7-20.7V89.9a20.8 20.8 0 0 1 20.7-20.8h107.8a4.6 4.6 0 1 1 0 9.1H58.9a11.7 11.7 0 0 0-11.6 11.7v136.6a11.6 11.6 0 0 0 11.6 11.6h107.8a4.7 4.7 0 0 1 4.6 4.6 4.6 4.6 0 0 1-4.6 4.5z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

LogoutIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { LogoutIcon }
